import React from 'react';
import { Plane, ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { popularRoutes } from '../mock';

const PopularRoutesSection = () => {
  const { language } = useLanguage();

  return (
    <section id="popular-routes" className="py-20 bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-5xl float-animation">✈️</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-orange-500 via-pink-500 to-purple-600 bg-clip-text text-transparent">
            {language === 'en' ? 'Incredible Fares We Found' : 'أسعار مذهلة وجدناها'}
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            {language === 'en' 
              ? 'Real deals from Muscat to the world! These are actual fares our members are booking right now.' 
              : 'عروض حقيقية من مسقط إلى العالم! هذه أسعار فعلية يحجزها أعضاؤنا الآن.'}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {popularRoutes.map((route, index) => (
            <div
              key={route.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 card-cartoon border-2 border-transparent hover:border-orange-200"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={route.image}
                  alt={`${route.from} to ${route.to}`}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute top-4 right-4 bg-white rounded-full p-3 shadow-lg bounce-light">
                  <span className="text-2xl">{route.icon}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <div className="flex items-center justify-between text-white">
                    <span className="font-bold text-lg">{route.from}</span>
                    <Plane className="w-5 h-5 rotate-45" />
                    <span className="font-bold text-lg">{route.to}</span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                {/* Price */}
                <div className="mb-4">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <Sparkles className="w-5 h-5 text-orange-500" />
                    <span className="text-3xl font-bold bg-gradient-to-r from-orange-500 to-pink-500 bg-clip-text text-transparent">
                      {route.fare} {route.currency}
                    </span>
                  </div>
                  <p className="text-center text-sm text-gray-600">
                    {language === 'en' ? 'Total Fare' : 'السعر الإجمالي'}
                  </p>
                </div>

                {/* Airlines */}
                <div className="mb-3">
                  <p className="text-xs font-semibold text-gray-500 mb-1">
                    {language === 'en' ? 'Airlines:' : 'الخطوط الجوية:'}
                  </p>
                  <p className="text-sm text-gray-700">{route.airlines}</p>
                </div>

                {/* Reason */}
                <div className="mb-4">
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {route.reason[language]}
                  </p>
                </div>

                {/* CTA Button */}
                <button 
                  onClick={() => {
                    const element = document.getElementById('pricing');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white font-bold py-3 px-4 rounded-xl transition-all duration-300 flex items-center justify-center gap-2 group"
                >
                  {language === 'en' ? 'Get Alerts' : 'احصل على التنبيهات'}
                  <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-gray-700 mb-4">
            {language === 'en' 
              ? '💡 Want alerts for these deals? Subscribe now and never miss a bargain!' 
              : '💡 تريد تنبيهات لهذه العروض؟ اشترك الآن ولا تفوت أي صفقة!'}
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('pricing');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gradient-to-r from-purple-500 to-orange-500 hover:from-purple-600 hover:to-orange-600 text-white font-bold py-4 px-10 rounded-full text-lg transition-all duration-300 transform hover:scale-105 shadow-xl"
          >
            {language === 'en' ? 'Subscribe Now' : 'اشترك الآن'} ✨
          </button>
        </div>
      </div>
    </section>
  );
};

export default PopularRoutesSection;
